import styled from "styled-components";
import {useNavigate} from "react-router-dom";
import {useMediaQuery} from "@uidotdev/usehooks";
import {colors} from "../../../util/colors.ts";
import {SilverButton} from "../../../components/LayoutWrapperCandidate.tsx";

interface PromotionalCardProps {
    style?: React.CSSProperties;
}

export const PromotionalCard = ({style}: PromotionalCardProps) => {
    const navigate = useNavigate();
    const isMobile = useMediaQuery("only screen and (max-width : 768px)");

    return (
        <JobRowItemWrapper style={style}>
            <BgWrapper>
                <ItemDetails>
                    <InfoContainer>
                        <h3 style={{width: isMobile ? "fit-content" : "80%", marginTop: 0}}>
                            Wir arbeiten daran Ihnen hier in Kürze mehr Jobs aus Ihrer Region zu präsentieren.
                        </h3>
                        <PoolItemMeta>
                            Sie wollen nicht warten? Sichern Sie sich jetzt Zugriff auf 100.000+ Teilzeit-Jobs und KI-Bewerbungshilfe mit silver+
                        </PoolItemMeta>
                    </InfoContainer>
                </ItemDetails>
                <ItemBtns>
                    <SilverButton
                        onClick={() => navigate('/silverplus')}
                        shape="round"
                        style={{width: 200}}
                        type="primary"
                    >
                        silver+ entdecken
                    </SilverButton>
                </ItemBtns>
            </BgWrapper>
        </JobRowItemWrapper>
    );
};

const JobRowItemWrapper = styled.div`
    background: ${colors.bg};
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 767px) {
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        padding: 0;
        border-bottom: none;
    }
`;

const BgWrapper = styled.div`
    width: 100%;
    padding: 8px;
    min-height: 130px;
    background: white !important;
    border-bottom: 1px solid #d9d9d9;
    border-radius: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 767px) {
        background: ${colors.bg} !important;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        padding: 0;
        border-bottom: none;
    }
`;

const ItemDetails = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    width: 80%;
    justify-content: space-between;
    @media (max-width: 767px) {
        align-items: flex-start;
        flex-direction: column;
        width: calc(100% - 4px);
        padding: 8px;
        box-shadow: 0 .125rem .25rem rgba(45, 45, 45, .12), 0 .0625rem .1875rem rgba(45, 45, 45, .16), 0 0 .125rem rgba(45, 45, 45, .2);
        background: white;
        border-radius: 4px;
        margin: 0 2px;
    }
`;

const InfoContainer = styled.div`
    flex: 1;
    min-width: 0;
    @media (max-width: 767px) {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
    }
`;

const ItemBtns = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 16px;
    gap: 8px;
    flex-shrink: 0;
    @media (max-width: 767px) {
        padding-top: 3px;
        margin: 0;
        width: 100%;
        align-items: center;
    }
`;

const PoolItemMeta = styled.p`
    margin: 0 0 4px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    color: #696969;
`;
